var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 158,
    viewBox: "0 0 311 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311 157H151.5C147.082 157 143.5 153.418 143.5 149V9C143.5 4.58172 139.918 1 135.5 1H0",
    stroke: "#00FFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep33);
export default __webpack_public_path__ + "static/media/step_3 (3).db3584224e780192a1265a6dbe2083d8.svg";
export { ForwardRef as ReactComponent };